import Cookies from 'js-cookie'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

// Store for persistent query params
const persistentParams: Map<string, string> = new Map()

// Helper function to convert query value to string
const queryValueToString = (value: string | (string | null)[] | null): string => {
  if (Array.isArray(value)) {
    return value.filter((v) => v !== null).join(',')
  }
  return value ?? ''
}

// Helper function to get or set vendor cookie
const handleVendorCookie = (value?: string): string => {
  const defaultVendor = 'W'
  if (value) {
    Cookies.set('v', value, { expires: 365 }) // Set cookie to expire in 1 year
    return value
  }
  return Cookies.get('v') || defaultVendor
}

export async function deviceDetect(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const currentQuery: LocationQuery = to.query
  const newQuery: LocationQuery = { ...Object.fromEntries(persistentParams) }

  // Merge current query params with persistent params
  Object.entries(currentQuery).forEach(([key, value]) => {
    newQuery[key] = value
  })

  // Handle vendor query param and cookie
  if (newQuery.v) {
    newQuery.v = handleVendorCookie(queryValueToString(newQuery.v))
  } else {
    newQuery.v = handleVendorCookie()
  }

  // Update persistentParams with new query params
  Object.entries(newQuery).forEach(([key, value]) => {
    persistentParams.set(key, queryValueToString(value))
  })

  // If the route already has the correct query params, proceed
  if (JSON.stringify(currentQuery) === JSON.stringify(newQuery)) {
    next()
  } else {
    // Otherwise, update the route with the new query
    next({
      ...to,
      query: newQuery
    })
  }
}

type LocationQuery = Dictionary<string | (string | null)[] | null>

interface Dictionary<T> {
  [key: string]: T
}
